import React from 'react'
import Logo from 'components/logo'
import { useNavigate } from 'react-router-dom'
import { scoreColors } from 'constants/creditScore'
import useViewport from 'hooks/useViewport'
import { BackArrow } from 'assets/icons'
import UserCard from 'components/UserCard'
import { useDesktopSideMenuStore } from 'store'

interface HeaderProps {
  isSectionHome?: boolean
  mobileHeaderColor?: keyof typeof scoreColors
  title?: string
  forcedBackNavigation?: () => void
  hasBackButton?: boolean
}

const Header = ({
  isSectionHome = false,
  mobileHeaderColor = 'default',
  title = '',
  forcedBackNavigation = null,
  hasBackButton = true
}: HeaderProps) => {
  const { isOpen } = useDesktopSideMenuStore()
  const navigate = useNavigate()
  const { isMobile } = useViewport()

  const handleClickArrowBack = () => {
    if (forcedBackNavigation) {
      forcedBackNavigation()
    } else {
      navigate(-1)
    }
  }

  return (
    <header
      className={`z-50 md:pr-32 max-w-[100vw] fixed w-full h-[4.5rem] px-4 py-3 md:py-4 flex justify-between items-center ${scoreColors[mobileHeaderColor]} md:bg-[#F8F8F6] md:stroke-black md:text-black`}
    >
      <div id='left-layout' className='w-full flex items-center grow'>
        {isMobile && !isSectionHome && hasBackButton ? (
          <button type='button' id='backButton' onClick={handleClickArrowBack}>
            <span className='sr-only'>Volver</span>
            <BackArrow className='md:stroke-green-800 h-6 w-6 md:mr-2' />
          </button>
        ) : null}
        {!isSectionHome ? (
          <h1
            className={`font-bold -pl-6 text-center self-center flex-grow text-base leading-snug md:hidden md:text-base ${
              isMobile && !isSectionHome && hasBackButton ? 'pr-6' : ''
            }`}
          >
            {title}
          </h1>
        ) : (
          <Logo className='flex md:hidden' showAlways />
        )}
        <h1
          className={`font-bold text-lg flex-grow leading-snug text-color-black hidden md:flex transition-all ease-in-out duration-300 ${
            isOpen ? 'md:pl-[12.125rem]' : 'md:pl-0'
          }`}
        >
          {title}
        </h1>
      </div>

      {isSectionHome || !isMobile ? (
        <div className='justify-end min-w-fit self-end flex'>
          <UserCard />
        </div>
      ) : null}
    </header>
  )
}

export default Header
